export const SET_TENANT_CONTEXT = "SET_TENANT_CONTEXT"
export const RESET_TENANT_CONTEXT = "RESET_TENANT_CONTEXT"
export const SET_TENANT_ROLES = "SET_TENANT_ROLES"
